import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MuiAnimationTiming } from '../../utility';

@Component({
  selector: 'mui-hero-page-title',
  templateUrl: './mui-hero-page-title.component.html',
  animations: [
    trigger('pageTitleAnimation', [
      transition(
        ':enter',
        group([
          query(
            '.mui-hero-page-title__title',
            [
              style({ opacity: 0, transform: 'translateY(-0.25em)' }),
              animate(MuiAnimationTiming.EASE_OUT, style({ opacity: 1, transform: 'translateY(0)' }))
            ],
            { optional: true }
          ),
          query(
            '.mui-hero-page-title__subtitle',
            [
              style({ opacity: 0, transform: 'translateY(0.25em)' }),
              animate(MuiAnimationTiming.EASE_OUT, style({ opacity: 1, transform: 'translateY(0)' }))
            ],
            { optional: true }
          ),
          query(
            '.mui-hero-page-title__divider',
            [style({ transform: 'scaleX(0)' }), animate('1s cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ transform: 'scaleX(1)' }))],
            { optional: true }
          )
        ])
      )
    ])
  ],
  styleUrls: ['./mui-hero-page-title.component.scss']
})
export class MuiHeroPageTitleComponent implements OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;
  @HostBinding('class.mui-hero-page-title') readonly _muiBaseClass = true;

  ngOnInit(): void {
    if (this.title == null) {
      throw new TypeError('The input "title" required');
    }
  }
}
